import { PrimaryDialog, BottomSheetDialog } from "@foodpilot/foods";
import { useTheme, useMediaQuery } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { UserProperty } from "src/context/Property/Builder/PropertyBuilder";
import { DisplayValue } from "./DisplayValue";
import { DisplayGroup } from "./DisplayGroup";
import { DisplayMulti } from "./DisplayMultivalue";

export type ModalData = UserProperty<unknown>;

type PropertyModalProps = {
    isOpen: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    property: ModalData | null;
};
export const PropertyModal = (props: PropertyModalProps) => {
    const { isOpen, setOpen, property } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (property === null) return null;

    const titleText = `${property.property.title} - ${t("campaign")} - ${property.campaign?.label}`;
    const contentElement = <PropertyDisplay property={property} />;

    if (isMobile) {
        return <BottomSheetDialog open={isOpen} setOpen={setOpen} title={titleText} content={contentElement as any} />;
    }

    return (
        <PrimaryDialog
            open={isOpen}
            setOpen={setOpen}
            onValidate={() => {}}
            onCancel={() => {}}
            options={{
                title: titleText,
                content: contentElement as any,
            }}
            cancelText={t("primarydialog.cancel")}
            validateText={t("primarydialog.validate")}
        />
    );
};

type PropertyDisplayProps = {
    property: ModalData;
};
const PropertyDisplay = (props: PropertyDisplayProps) => {
    const { property } = props;

    if (property.type === "value") {
        return <DisplayValue property={property} />;
    }

    if (property.type === "group") {
        return <DisplayGroup property={property} />;
    }

    if (property.type === "multi") {
        return <DisplayMulti property={property} />;
    }

    return null;
};
